import { Moment } from "moment";

export const calculateDuration = (fromDate: Date, toDate: Date) => {
  const timeDiff = new Date(toDate).getTime() - new Date(fromDate).getTime();

  const totalMinutes = Math.floor(timeDiff / (60 * 1000));
  const days = Math.floor(totalMinutes / (24 * 60));
  const remainingMinutesAfterDays = totalMinutes % (24 * 60);
  const hours = Math.floor(remainingMinutesAfterDays / 60);
  const minutes = remainingMinutesAfterDays % 60;

  return { days, hours, minutes };
};

export const formatDate = (date: Moment | null): string => {
  if (!date) {
    return "";
  }
  return date.format("MMM D");
};
